import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { getCustomersInGroup } from '../../../api/inventory/get-customers-in-group'
import { getItemSpecialPricingByCustomerGroup } from '../../../api/inventory/get-item-special-pricing-by-customer-group'

const initialState = {
  isFetchingCustomerGroupAccount: false,
  isFetchingCustomerSpecialPricing: false,
  customerSpecialPricing: [],
  customerGroupAccount: [],
  selectedCustomerGroup: null,
  fetchCustomerGroupAccountError: null,
  fetchCustomerSpecialPricingError: null,
}

export const fetchCustomerGroupAccount = createAsyncThunk(
  'customerGroup/fetchCustomerGroupAccount',
  async (args, { getState, rejectWithValue }) => {
    const state = getState()
    const request = {
      id: state.customerGroup.selectedCustomerGroup.id,
    }
    try {
      const response = await getCustomersInGroup(request)
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

export const fetchCustomerSpecialPricing = createAsyncThunk(
  'customerGroup/fetchCustomerSpecialPricing',
  async (args, { getState, rejectWithValue }) => {
    const state = getState()
    const request = {
      id: state.customerGroup.selectedCustomerGroup.id,
    }
    try {
      const responseSpecialPricing = await getItemSpecialPricingByCustomerGroup(request)
      return responseSpecialPricing?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const customerGroupSlice = createSlice({
  name: 'customerGroup',
  initialState,
  reducers: {
    setSelectedCustomerGroup(state, action) {
      state.selectedCustomerGroup = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerGroupAccount.pending, (state) => {
        state.isFetchingCustomerGroupAccount = true
        state.customerGroupAccount = []
        state.fetchCustomerGroupAccountError = null
      })
      .addCase(fetchCustomerGroupAccount.fulfilled, (state, action) => {
        state.isFetchingCustomerGroupAccount = false
        state.customerGroupAccount = action.payload
      })
      .addCase(fetchCustomerGroupAccount.rejected, (state, action) => {
        state.isFetchingCustomerGroupAccount = false
        state.fetchCustomerGroupAccountError = action.payload
      })
      .addCase(fetchCustomerSpecialPricing.pending, (state) => {
        state.isFetchingCustomerSpecialPricing = true
        state.customerSpecialPricing = []
        state.fetchCustomerSpecialPricingError = null
      })
      .addCase(fetchCustomerSpecialPricing.fulfilled, (state, action) => {
        state.isFetchingCustomerSpecialPricing = false
        state.customerSpecialPricing = action.payload
      })
      .addCase(fetchCustomerSpecialPricing.rejected, (state, action) => {
        state.isFetchingCustomerSpecialPricing = false
        state.fetchCustomerSpecialPricingError = action.payload
      })
      .addCase('itemSpecialPricing/fetchItemSpecialPricing/pending', (state) => {
        state.customerGroupAccount = []
        state.customerSpecialPricing = []
        state.selectedCustomerGroup = null
      })
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export const { setSelectedCustomerGroup } = customerGroupSlice.actions

export default customerGroupSlice.reducer
